import InsuredToSave from '@/modules/common/common/models/MID/InsuredToSave'

export default class LifeSaveInsuredsRequest {
  quotationId!: string
  insureds!: InsuredToSave[]

  constructor(data: any) {
    this.quotationId = data.quotationId
    this.insureds = data.insureds?.map((insured: any) => new InsuredToSave(insured))
  }
}
